import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {Helmet} from "react-helmet"
//import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {WEBSITE_NAME} from './config'
import Header from './components/Header'
import Scrollbar from './fm/lib/Scrollbar'
import Loading from './fm/lib/Loading'
import NProgressBar from './fm/lib/NProgressBar'
import Node from './fm/Node'
import Footer from './components/Footer'
import ContentView from './fm/admin/content/ContentView'
import LibraryView from './components/auth/LibraryView'
import LibraryLink from './components/auth/LibraryLink'
import Dialogs from './fm/admin/Dialogs'
//import {regions} from './config'
//import Region from './fm/Region'
import PersonDetails from './components/PersonDetails'
import AdminView from './fm/admin/AdminView'
class Layout extends PureComponent {
    render() {
  		const { location } = this.props
  		
  		return (
			<div id='page'>
			    <Helmet>
			        <meta property="og:url" content={window.location.origin + location} />
                    <meta property="og:type" content="business.business" />
                    <meta property="og:title" content={WEBSITE_NAME} />
                    <meta property="og:description" content="" />
        	        <meta property="og:locale" content="ro_RO" />
			        <meta property="twitter:url" content={window.location.origin + location} />
					<meta property="twitter:card" content="summary" />
					<meta property="twitter:title" content={WEBSITE_NAME} />
					<meta property="twitter:description" content="" />
			    </Helmet>
			    <div id='bg-page'/>
			    <NProgressBar/>
				<Header/>
				{/*Object.keys(regions).map(region => <Region key={region} name={region} region={regions[region]}/>)*/}
      				<div id='main' className='main'>
      					<Scrollbar register={true}>
      						{/*<Node path={location}/>*/}
      						<Node transition={false}/>
      						<Footer/>
      					</Scrollbar>
        			</div>
				{/*
				<ReactCSSTransitionGroup
        			transitionName="main"
        			transitionEnterTimeout={300}
        			transitionLeaveTimeout={300}
        			transitionAppear={true}
      				transitionAppearTimeout={300}>
      				<div id='main' className='main' key={location}>
      					<Scrollbar register={true}>
      						<Node path={location}/>
      						<Footer/>
      					</Scrollbar>
        			</div>
        		</ReactCSSTransitionGroup>
        		*/}
				<Loading/>
				<ContentView/>
				<LibraryView/>
				<LibraryLink/>
				<Dialogs/>
				<PersonDetails/>
				<AdminView/>
      		</div>
    	);
  	}
}
const mapStateToProps = state  => ({
	//location: state.page.location
})
export default connect(mapStateToProps)(Layout);
//export default connect(mapStateToProps, {doAuthentication})(Layout);
//export default connect(mapStateToProps, {fetchLocation, doAuthentication, push})(Layout);



// WEBPACK FOOTER //
// ./src/Layout.js